var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRed2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0004 0C25.9816 0 4 21.9812 4 49C4 76.0188 25.9816 98 53.0004 98C80.0188 98 102 76.0188 102 49C102 21.9812 80.0184 0 53.0004 0ZM53.0004 83.802C33.7794 83.802 18.198 68.221 18.198 49C18.198 29.779 33.7794 14.198 53.0004 14.198C72.2206 14.198 87.8024 29.779 87.8024 49C87.8024 68.221 72.2202 83.802 53.0004 83.802Z",
    fill: "url(#paint0_linear_1_27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0004 18.7035C36.2943 18.7035 22.7035 32.2944 22.7035 49C22.7035 65.7056 36.2947 79.2965 53.0004 79.2965C69.706 79.2965 83.2969 65.7056 83.2969 49C83.2969 32.2944 69.7056 18.7035 53.0004 18.7035ZM79.417 47.0684H64.7169C64.4166 45.2106 63.6828 43.4973 62.6243 42.0327L73.0022 31.6548C76.6453 35.85 78.9908 41.1956 79.417 47.0684ZM54.9012 22.5807C60.7705 22.9992 66.1142 25.3359 70.3117 28.9685L59.9361 39.3445C58.4715 38.2864 56.7586 37.553 54.9012 37.2526V22.5807ZM51.0992 22.5807V37.2523C49.2418 37.5526 47.5285 38.286 46.0639 39.3445L35.6879 28.9689C39.8854 25.3363 45.2299 22.9992 51.0992 22.5807ZM32.997 31.6552L43.3753 42.0331C42.3168 43.4973 41.5834 45.2106 41.2831 47.068H26.583C27.0092 41.1956 29.3547 35.8504 32.997 31.6552ZM26.5787 50.87H41.2834C41.5834 52.7274 42.3172 54.4407 43.3756 55.9053L32.9689 66.312C29.3297 62.1069 26.9911 56.7512 26.5787 50.87ZM51.0992 75.4193C45.2141 74.9997 39.8577 72.6518 35.6548 69.0026L46.0639 58.5936C47.5285 59.652 49.2418 60.3854 51.0992 60.6858V75.4193ZM51.0992 56.7747V56.8024C50.2787 56.603 49.5086 56.2788 48.8071 55.8499L48.8252 55.8318C47.7279 55.1626 46.8062 54.2409 46.137 53.1432L46.1193 53.1609C45.6904 52.4594 45.3662 51.6898 45.1668 50.8693H45.1941C45.0459 50.259 44.9588 49.6245 44.9588 48.9684C44.9588 48.3124 45.0462 47.6778 45.1941 47.0676H45.1668C45.3662 46.2475 45.69 45.4778 46.1193 44.7763L46.137 44.794C46.8062 43.6967 47.7283 42.7746 48.8252 42.1058L48.8071 42.0877C49.5086 41.6588 50.2787 41.3342 51.0992 41.1352V41.1629C51.7098 41.0147 52.3439 40.9273 53.0004 40.9273C53.6568 40.9273 54.291 41.0147 54.9016 41.1629V41.1352C55.7221 41.3346 56.4917 41.6584 57.1929 42.0873L57.1748 42.1054C58.2725 42.7742 59.1942 43.6963 59.8634 44.7937L59.8811 44.7759C60.3104 45.4774 60.6346 46.2475 60.834 47.068H60.8067C60.9549 47.6782 61.0419 48.3127 61.0419 48.9688C61.0419 49.6249 60.9545 50.2594 60.8067 50.8697H60.834C60.6346 51.6901 60.3108 52.4602 59.8811 53.1617L59.8634 53.144C59.1942 54.2413 58.2721 55.163 57.1748 55.8322L57.1929 55.8499C56.4917 56.2788 55.7221 56.603 54.9016 56.8024V56.7747C54.291 56.9229 53.6568 57.0103 53.0004 57.0103C52.3439 57.0103 51.7098 56.9233 51.0992 56.7747ZM54.9012 75.4193V60.6858C56.7586 60.3854 58.4715 59.652 59.9361 58.5939L70.3448 69.0026C66.1423 72.6518 60.7859 74.9997 54.9012 75.4193ZM73.0311 66.312L62.6247 55.9057C63.6832 54.4411 64.4166 52.7278 64.7173 50.87H79.4216C79.0089 56.7512 76.6707 62.1069 73.0311 66.312Z",
    fill: "url(#paint1_linear_1_27)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_27",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_27",
    x1: 53,
    y1: -27,
    x2: 53,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF912B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FFCB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE811C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_27",
    x1: 53,
    y1: -27,
    x2: 53,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF912B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FFCB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE811C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed2);
export default __webpack_public_path__ + "static/media/red2.ccb28bb0.svg";
export { ForwardRef as ReactComponent };